import HoverTooltip from '@deltek/specification-client/core/Feedbacks/HoverTooltip'
import { makeStyles, Theme } from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'

interface ManufacturarOptionIconProps {
    onIconClick?: () => void
    iconColor?: string
}
const useStyles = makeStyles((theme: Theme) => ({
    iconBase: {
        width: 20,
        height: 20,
        marginLeft: theme.spacing(0.4),
        marginRight: theme.spacing(0.4),
        borderRadius: 3,
        cursor: 'pointer',
    },
    icon: {
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        height: 16,
        width: 28,
    },
}))
const ManufacturarOptionIcon = ({
    onIconClick,
    iconColor,
}: ManufacturarOptionIconProps) => {
    const classes = useStyles()

    return (
        <HoverTooltip
            text="Manufacturer options available"
            enterDelay={1000}
            enterNextDelay={1000}
        >
            <div
                className={clsx('dvManufacturerOption', classes.iconBase)}
                data-testid={`dvManufacturerOption`}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="14"
                    viewBox="0 0 24 14"
                    className={classes.icon}
                    fill={iconColor}
                    onClick={onIconClick}
                    role="button"
                    tabIndex={0}
                    data-testid="imgManufacturerOption"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0 7C0 3.13401 3.13401 0 7 0H17C20.866 0 24 3.13401 24 7C24 10.866 20.866 14 17 14H7C3.13401 14 0 10.866 0 7ZM11 3H13V6.00001H16V8.00001H13V11H11V8.00001H8V6.00001H11V3Z"
                    />
                </svg>
            </div>
        </HoverTooltip>
    )
}
export default ManufacturarOptionIcon
